import "./bannertop.css";
import { useState } from "react";
import { isMobile, s3url } from "../utility/constand";
import APIDocsForm from "./Modals/ApiDocsForm/APIDocsForm";

const BannerTop = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const backgroundImage = isMobile
    ? `${s3url}/Mobile_bank_background.svg`
    : `${s3url}/bankBackground.svg`;
  return (
    <div
      className="banner-top"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="banner-top-content">
        <span className="banner-top-heading">Bank Statement</span>
        <p className="banner-top-main-text">
          Analyser that Doesn’t Miss a Risk
        </p>
        <p className="banner-top-sub-text">
          Verify authenticity, assess repayment capacity, and detect hidden
          risks instantly.
        </p>
        <div className="banner-buttons">
          <button
            className="banner-btn banner-doc"
            onClick={() => setModalOpen(true)}
          >
            View API Documentation
          </button>
          {/* <button className="banner-btn banner-talk">Talk to Us</button> */}
        </div>
      </div>
      <APIDocsForm
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        key={"modal"}
      />
    </div>
  );
};

export default BannerTop;
